import { ICancelOrder, IOrderStatus, IRejection } from "../interfaces/order";
import { GET, PATCH, POST } from "../utils/constants";
import { fetchData } from "../utils/dataProvider";
import { trimValue } from "../utils/form";

export const cancelOrder = ({
  trackingNumber,
  reason,
  selectedMarketplace,
}: ICancelOrder) =>
  fetchData({
    url: `/orders/cancel/${trackingNumber}${
      selectedMarketplace && `?marketplaceId=${selectedMarketplace}`
    }`,
    method: PATCH,
    body: { reason: trimValue(reason) },
  });

export const updateStatusAlias = (status: IOrderStatus) =>
  fetchData({
    url: "/orders/customization/alias",
    method: PATCH,
    body: { status: status.id, alias: status.label },
  });

export const getStatusAliasList = (marketplaceId?: string) =>
  fetchData({
    url: `/orders/customization/alias${
      marketplaceId ? `?marketplaceId=${marketplaceId}` : ""
    }`,
    method: GET,
  });

export const getEmailTemplateList = () =>
  fetchData({ url: "/orders/customization/email-templates", method: GET });

export const updateEmailTemplate = (body: any) =>
  fetchData({
    url: "/orders/customization/email-template",
    method: PATCH,
    body,
  });

export const updateEmailDisabledConfiguration = (body: any) =>
  fetchData({
    url: "/orders/customization/email-templates/toggle-status-email",
    method: PATCH,
    body,
  });

export const editOrderStatus = ({
  trackingNumber,
  body,
  marketplaceId,
  rejection_info,
}: {
  trackingNumber: string | number;
  body: any;
  marketplaceId?: string;
  rejection_info?: IRejection;
}) => {
  if (rejection_info) body.rejection_info = rejection_info;
  return fetchData({
    url: `/orders/${trackingNumber}${
      marketplaceId ? `?marketplaceId=${marketplaceId}` : ""
    }`,
    method: PATCH,
    body,
  });
};

export const bulkEditOrderStatus = ({
  body,
  marketplaceId,
  trackingNumbers,
  rejection_info,
}: {
  trackingNumbers: (string | number)[];
  body: any;
  marketplaceId?: string;
  rejection_info?: IRejection;
}) => {
  if (rejection_info) body.rejection_info = rejection_info;
  body.tracking_ids = trackingNumbers;
  return fetchData({
    url: `/orders/bulk${
      marketplaceId ? `?marketplaceId=${marketplaceId}` : ""
    }`,
    method: PATCH,
    body: { orders: [{ ...body }] } as any,
  });
};

export const updateOwnFleetOrdersByCSV = (formData: FormData) => {
  const url = "/orders/update-order-csv";
  return fetchData({
    url,
    method: POST,
    body: formData,
  });
};

export const getCSVStatus = (marketplaceId: string) => {
  const url = `/orders/update-order-csv?marketplaceId=${marketplaceId}&sort_by=created_at_desc&limit=1`;
  return fetchData({
    url,
    method: GET,
  });
};

export const getCSVExample = () => {
  return fetchData({
    url: "/orders/update-order-csv/example",
    method: GET,
  });
};

// ─── Seller email customization ─────────────────────────────

export const getMerchantToggleConfig = () =>
  fetchData({
    url: "/orders/customization/events-config",
    method: GET,
  });

export const updateMerchantToggleConfig = (enabledMerchantToggle: boolean) =>
  fetchData({
    url: "/orders/customization/events-config",
    method: PATCH,
    body: { enabledMerchantToggle },
  });

export const getMerchantEffectiveEmailConfig = (marketplaceId: number) =>
  fetchData({
    url: `/orders/merchant-customization/email-config?marketplaceId=${marketplaceId}`,
    method: GET,
  });

export const updateMerchantEmailConfig = (
  marketplaceId: number,
  events: Record<string, { disabled: boolean }>,
) =>
  fetchData({
    url: `/orders/merchant-customization/email-config?marketplaceId=${marketplaceId}`,
    method: PATCH,
    body: { events },
  });
